import { apiRequest } from "../api.jsx";

export const getWishlist = () => apiRequest("/wishlist");
export const addWishlistProduct = (productId) =>
  apiRequest("/wishlist/add", "POST", { productId });
export const removeWishlistProduct = (productId) =>
  apiRequest(`/wishlist/remove/${productId}`, "DELETE");
